import { API } from '../config/config';

const ImagenesService = {
  upload: (images, onProgress) => uploadImages(images, onProgress),
  download: (images) => downloadImages(images),
  get: (name) => getImage(name),
  getAll: () => getAll()
};

const getAll = async () => {
  try {
    var response = await API.get('/images')
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    //throw new Error(err)
  }
}

const getImage = async (name) => {
  try {
    var response = await API.get(`/getImages/${name}`)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    //throw new Error(err)
  }
}

const uploadImages = async (images, onProgress) => {
  try {
    const config = onProgress ? { onUploadProgress: (evt) => {
      if (evt.total) {
        const percent = Math.round((evt.loaded * 100) / evt.total);
        onProgress(percent);
      }
    }} : {};
    const response = await API.post('/uploadImage2', images, config);
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err);
  }
};

const downloadImages = async (image) => {
  try {
    var response = await API.post('/downloadImage', image)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

export default ImagenesService;
